import { cn } from '@/app/utils/cn'
import { getVideoThumbnail } from '@/app/utils/getVideoThumbnail'
import { withCdn } from '@/app/utils/withCdn'
import { Dropzone } from '@/view/components/Dropzone'
import { Image } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'

interface ThumnailDropzoneProps {
  value: File | undefined
  onChange: (file: File) => void
  className?: string
}

export const ThumnailDropzone = ({
  value,
  onChange,
  className,
}: ThumnailDropzoneProps) => {
  const [thumb, setThumb] = useState<string | null>(null)
  const onDrop = useCallback(
    (files: File[]) => {
      if (!files.length) return
      onChange(files[0])
    },
    [onChange],
  )

  useEffect(() => {
    const generateThumbnail = async () => {
      if (!value) return

      let newThumb = ''
      if (value.type.includes('video/') || value.type.includes('mp4'))
        newThumb = await getVideoThumbnail(value)
      else if (value.type.includes('image/'))
        newThumb = URL.createObjectURL(value)
      else newThumb = withCdn(value.name)

      setThumb(newThumb)
    }

    generateThumbnail()
  }, [value])

  return (
    <Dropzone
      dropzoneOptions={{
        accept: {
          'image/*': ['.jpg', '.jpeg', '.png'],
          'video/*': ['.mp4'],
        },
        maxFiles: 1,
      }}
      onDrop={onDrop}
      value={value ? [value] : null}
      render={() => {
        return thumb ? (
          <img
            src={thumb}
            alt="thumbnail"
            className={cn(
              'h-[103px] w-[210px] overflow-hidden rounded-md object-cover',
              className,
            )}
          />
        ) : (
          <div className="flex h-[103px] w-full flex-col items-center justify-center">
            <Image size={48} strokeWidth={1.5} />
            <p className="mt-2 text-xs">
              Arraste e solte ou clique aqui para fazer upload
            </p>
          </div>
        )
      }}
    />
  )
}
